var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card pb-0 mb-3",style:({'paddingBottom':'0 !important'})},[_c('div',{staticClass:"card-body"},[_c('data-table',{ref:`${_vm.model}List`,attrs:{"model":_vm.model,"endpoint":_vm.endpoint,"route-params":_vm.routeParams,"route-context":_vm.$route.name},on:{"action":_vm.doAction}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }